import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface SaveBarProps {
  hasChanges: boolean;
  isSaving: boolean;
}

export function SaveBar({ hasChanges, isSaving }: SaveBarProps) {
  const { t } = useTranslation('assistant');
  return (
    <div className="flex justify-end">
      <Button type="submit" disabled={hasChanges === false} isLoading={isSaving}>
        {t('configuration.save')}
      </Button>
    </div>
  );
}
